import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import gsap from 'gsap'

export const initAlpine = () => {
  window.Alpine = Alpine
  window.gsap = gsap

  Alpine.plugin(collapse)

  Alpine.store('hasPreloader', {
    check: true,
    setPreloaderState() {
      this.check = !this.check
    }
  })

  Alpine.start()
}

export default () => {}
